/**
 * @class OptionDropdown
 * @classdesc Represents an option as dropdown
 *
 * @extends Core.Component
 */
export default class OptionDropdown extends Core.Component {
  /**
   * Returns the selected value or false if unselected
   */
  get selectedValue() {
    const input = this.query('input-select');

    if (input) {
      return input.value !== '' ? input.value : false;
    }

    return false;
  }

  set selectedValue(value) {
    const input = this.query('input-select');

    input.value = value;
  }

  get position() {
    return this.data.position;
  }

  onMount() {
    this.events.register(this.el, 'change', () => {
      const inputSelect = this.query('input-select');
      const { selectedValue } = this;

      if (inputSelect) {
        if (selectedValue) {
          inputSelect.label = this.data.chosen_option;
        } else {
          inputSelect.label = this.data.chose_option;
        }
      }
    });
  }

  // This method does nothing.
  // It exists to match the selectable boxes interface
  setUnavailableValues() {
    return undefined;
  }

  disableValues(values) {
    const inputSelect = this.query('input-select');

    if (inputSelect) {
      inputSelect.disableValues(values);
    }
  }

  removeValues(values) {
    const inputSelect = this.query('input-select');

    if (inputSelect) {
      inputSelect.removeValues(values);
    }
  }
}
